import { render, staticRenderFns } from "./FavoriteAddressDialog.vue?vue&type=template&id=67c038f2&scoped=true&"
import script from "./FavoriteAddressDialog.vue?vue&type=script&lang=js&"
export * from "./FavoriteAddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteAddressDialog.vue?vue&type=style&index=0&id=67c038f2&lang=scss&scoped=true&"
import style1 from "./FavoriteAddressDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c038f2",
  null
  
)

export default component.exports